module.exports = __webpack_public_path__ + "assets/img/block-left-hover-22548961.png";